import { extendTailwindMerge } from 'tailwind-merge'

// Prevent `tailwind-merge` from treating these custom `text-*` classes as text colors.
export const mergeClass = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['hero', 'body', 'small', 'xsmall', 'caption'] }],
    },
  },
})
